import React, { Component } from "react";
import { checkTranslation, translate } from "../../../utils/useful";
import inputComponents from "../../inputs/inputComponents";

class RowInput extends Component {
    state = {}
    render() {
        let header = this.props.header;
        let Component = inputComponents[header.type]

        return (
            <div>
                {header.information?.label ? (
                    <div className="w-100 mb-1 text-start">
                        <label className={' text-small mrd-1 mld-1  ' + (header.information?.required ? 'required' : '')}>{checkTranslation(header.information?.label)}</label>
                    </div>
                ) : (
                    <div className="w-100 mb-1 text-start">
                        <label className={'color-gray-5 text-small mrd-1 mld-1  ' + (header.information?.required ? 'required' : '')}>{translate("Field Name")}</label>
                    </div>
                )}

                <div className={"flexc " + (header.information.inputClass ?? (this.props.inputClass ? this.props.inputClass : 'default-input-view '))} >
                    {Component && (
                        <div className="w-100  p-0" key={header.key}>
                            <Component changeValue={() => { }} data={null} ref={el => this["component-" + header.key] = el} header={header} />
                        </div>
                    )}
                </div>

                {header.information?.hint && (
                    <div className="w-100 mt-1  text-start ">
                        <p className='text-smaller color-gray-2 px-1' >{checkTranslation(header.information?.hint)}</p>
                    </div>
                )}
            </div>
        );
    }
}

export default RowInput;